"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublicTokenClient = void 0;
var _TokenClient = require("../TokenClient");
var _TokenRoutes = require("../TokenRoutes");
/**
 * Shorthand to TokenClient({ url: TokenRoutes.PUBLIC_ACCESS })
 */
class PublicTokenClient extends _TokenClient.TokenClient {
  constructor() {
    super({
      url: _TokenRoutes.TokenRoutes.PUBLIC_ACCESS
    });
  }
}
exports.PublicTokenClient = PublicTokenClient;
//# sourceMappingURL=PublicTokenClient.js.map